import {
  backdropClasses,
  paperClasses,
  buttonClasses,
  styled,
  IconButton as MuiIconButton,
  Typography as MuiTypography,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  Dialog as MuiDialog,
} from '@mui/material'

import { SubmitButton as SubmitButtonBase } from '../../components/submit-button/submit-button'

export const ModalDialog = styled(MuiDialog)(({ theme }) => ({
  userSelect: 'none',

  [`& .${paperClasses.root}`]: {
    background: theme.palette.common.white,
    borderRadius: 20,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.13)',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },

  [`& .${backdropClasses.root}`]: {
    backgroundColor: 'rgba(82, 82, 82, 0.3)',
  },
}))

export const CloseButton = styled(MuiIconButton)(({ theme }) => ({
  fontSize: 14,
  marginRight: theme.spacing(-1.5),
  marginTop: theme.spacing(-1.5),
  marginBottom: theme.spacing(-1.5),

  [`& .${buttonClasses.startIcon}`]: {
    color: '#636E79',
  },
}))

export const Title = styled(MuiTypography)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
}))

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: 0,
  paddingBottom: 14,
}))

export const DialogHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(2),
  marginRight: theme.spacing(2),
}))

export const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(3),
}))

export const HelperText = styled(MuiTypography)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  color: theme.palette.grey[800],
}))

export const SubmitButton = styled(SubmitButtonBase)(() => ({
  margin: '0 auto',
}))
